import { ReactElement } from 'react';
import { UpgradeModule } from '../components/UpgradeModule';
import { getRowCardOrders } from '../helpers/cards';
import { EnergyEfficiencyCard } from './components/EnergyEfficiencyCard';
import { EnergyContainer } from './components/styles';
import { TrendsCard } from './components/TrendsCard';

interface EnergyProps {
  hasEnergy: boolean;
  hasWater: boolean;
  loading: boolean;
}

export function Energy({
  hasEnergy,
  hasWater,
  loading,
}: Readonly<EnergyProps>): ReactElement {
  const orders = getRowCardOrders(hasWater);

  return (
    <EnergyContainer expanded={!hasWater} loading={loading}>
      {!hasEnergy && !loading && <UpgradeModule module="moreModules" />}
      <div>
        <TrendsCard
          hasEnergy={hasEnergy}
          loading={loading}
          order={orders.trends}
          expandedSplit={!hasWater && hasEnergy}
        />
        <EnergyEfficiencyCard
          loading={loading}
          order={orders.efficiency}
          expandedSplit={!hasWater && hasEnergy}
          hasEnergy={hasEnergy}
        />
      </div>
    </EnergyContainer>
  );
}
